import React from 'react'
import { Drawer, IconButton } from '@chakra-ui/react'
import { FiX } from 'react-icons/fi'

export interface OnboardingSideDrawerProps {
  open: boolean
  onOpenChange: (details: { open: boolean }) => void
  header?: React.ReactNode
  footer?: React.ReactNode
  children: React.ReactNode
}

export const OnboardingSideDrawer: React.FC<OnboardingSideDrawerProps> = ({
  open,
  onOpenChange,
  header,
  footer,
  children
}) => {
  return (
    <Drawer.Root open={open} onOpenChange={onOpenChange} placement="end">
      <Drawer.Backdrop />
      <Drawer.Positioner style={{ justifyContent: 'flex-end' }}>
        <Drawer.Content
          maxH="100vh"
          h="100vh"
          w={{ base: '100vw', sm: '480px', md: '560px', lg: '600px' }}
          maxW={{ base: '100vw', sm: '480px', md: '560px', lg: '600px' }}
          minW={{ base: '100vw', sm: '480px', md: '560px', lg: '600px' }}
          bg="white"
          borderLeftWidth={{ base: '0px', sm: '1px' }}
          borderColor="gray.200"
          boxShadow="xl"
          display="flex"
          flexDirection="column"
        >
          <Drawer.CloseTrigger
            position="absolute"
            top={4}
            right={4}
            zIndex={1}
            asChild
          >
            <IconButton
              variant="ghost"
              size="sm"
              aria-label="Close drawer"
            >
              <FiX />
            </IconButton>
          </Drawer.CloseTrigger>

          {header ? (
            <Drawer.Header borderBottomWidth="1px" borderColor="gray.200" flexShrink={0}>
              {header}
            </Drawer.Header>
          ) : null}

          <Drawer.Body overflowY="auto" flex={1} minH={0}>
            {children}
          </Drawer.Body>

          {footer ? (
            <Drawer.Footer borderTopWidth="1px" borderColor="gray.200" bg="gray.50" flexShrink={0}>
              {footer}
            </Drawer.Footer>
          ) : null}
        </Drawer.Content>
      </Drawer.Positioner>
    </Drawer.Root>
  )
}



